import React from 'react';
import { Box, Center, Radio, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from '../../../../../common/components/ArcButton';
import { SEHomeCard } from '../../../../../common/components/SEHomeCard';
import { SlidingAnimationPageBase } from '../../../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../../../common/constants';
import { DataDownloadIcon } from '../../../../../styles/custom-icons';

export function DeleteAccountArchive() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const greenIconColor = useColorModeValue('primaryBranding.600', 'primaryBranding.200');

  return (
    <SlidingAnimationPageBase px={4} title={t('Account.delete account')} backURL={`../start?direction=back`}>
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Text>
          {t('Account.deletion is permanent')} {t('Account.before you delete')}
        </Text>
        <SEHomeCard my={4} borderTopLeftRadius={'5px'} p={0} width="100%">
          <Center flexDirection="column" px={2}>
            <DataDownloadIcon color={greenIconColor} w="75px" h="75px" my={3} data-testid="download-data-icon" />
            <Text fontSize="xl" fontWeight={400} textAlign="center" data-testid="download-data-title">
              {t('Common.download')}
            </Text>
            <Text textAlign="center">
              {t('Account.you can request an archive')} {t('Account.export file format')} {t('Account.ready notice')}
            </Text>

            <ArcButton
              arcColor={'#3DCD57'}
              w="100%"
              mt={2}
              onClick={() =>
                navigate(
                  `../../data-archive?direction=forward&backURL=${encodeURIComponent(
                    '../delete-account/request-data-archive?direction=back'
                  )}`
                )
              }
              data-testid="request-data-archive-button"
            >
              {t('Account.request data archive')}
            </ArcButton>
            <Radio size="md" my={4} data-testid="dont-need-historical-data-input">
              <Text fontSize="xs">{t('Account.i dont need my data')}</Text>
            </Radio>
          </Center>
        </SEHomeCard>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            arcColor={'#3DCD57'}
            w="100%"
            py={6}
            mt="auto"
            onClick={() => navigate('../verify-details')}
            data-testid="continue-to-delete-button"
          >
            {t('Account.continue to delete')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
}
